/**
 * Data transformation utilities for customers
 * 
 * These functions handle sorting and filtering of customer data,
 * keeping business logic separate from UI components.
 */

/**
 * Sorts customers by specified key and direction
 * @param {Array} customers - Array of customers
 * @param {Object} sortConfig - { key: string, direction: 'asc' | 'desc' }
 * @returns {Array} Sorted customers
 */
export const sortCustomers = (customers, sortConfig) => {
    if (!sortConfig || !sortConfig.key) {
        return [...customers];
    }

    const sorted = [...customers];
    sorted.sort((a, b) => {
        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        // Handle date fields specially
        if (sortConfig.key === 'customer_created_at') {
            aValue = aValue ? new Date(aValue) : 0;
            bValue = bValue ? new Date(bValue) : 0;
        }

        if (aValue < bValue) {
            return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
            return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
    });

    return sorted;
};

/**
 * Filters customers by search term
 * @param {Array} customers - Array of customers
 * @param {string} searchTerm - Search term
 * @returns {Array} Filtered customers
 */
export const filterCustomers = (customers, searchTerm) => {
    if (!searchTerm) {
        return customers;
    }
    const term = searchTerm.toLowerCase();
    const termDigits = searchTerm.replace(/\D/g, '');
    return customers.filter((customer) => {
        const email = customer.customer_email?.toLowerCase() || '';
        const name = customer.customer_name?.toLowerCase() || '';
        const phoneRaw = customer.customer_phone?.toString() || '';
        const phoneLower = phoneRaw.toLowerCase();
        const phoneDigits = phoneRaw.replace(/\D/g, '');

        return (
            email.includes(term) ||
            name.includes(term) ||
            phoneLower.includes(term) ||
            (termDigits.length > 0 && phoneDigits.includes(termDigits))
        );
    });
};

